/**
 * Financial helper class (included by the helper service)
 *
 */
export class FinancialHelper {

    public addTax(value: number, rate: number) {
        return Number(value) * (100 + Number(rate)) / 100;
    }

    public subtractTax(value: number, rate: number) {
        return Number(value) / (100 + Number(rate)) * 100;
    }

    public getTaxValue(value: number, rate: number) {
        return Number(value) / 100 * Number(rate);
    }

    public subtractDiscountByValue(value: number, discountValue: number) {
        return Number(value) - discountValue;
    }

    public subtractDiscountByPercentage(value: number, discountPercentage: number) {
        return Number(value) * (100 - Number(discountPercentage)) / 100;
    }
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/financial.helper.ts